import type { Goal } from '../context/GoalsContext';
import type { AppColors } from './palettes';

export const getGoalTypeProgressColor = (type: Goal['type'], colors: AppColors): string => {
  switch (type) {
    case 'Savings':
      return colors.goalType.savings;
    case 'Debt':
      return colors.goalType.debt;
    case 'Investment':
      return colors.goalType.investment;
    default:
      return colors.goalType.savings;
  }
};
